import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { RenderDateTimeAll, RenderDateTime, RenderMoneda, getSimbolo } from "../../../Utils/renderField/renderTableField";

import Grid from '../../../Utils/Grid/index';
import { TableHeaderColumn } from 'react-bootstrap-table';
import DesgloseGastos from './desglose';

import LoadMask from "Utils/LoadMask/LoadMask";
import GridClientesProveedores from './gridClientesProveedores';
import GridDespachoInterno from './GridDespachoInterno';
import GridOtros from './GridOtros';


export default class DetalleItinerario extends Component {
    static propTypes = {
        item: PropTypes.object.isRequired,
        loader: PropTypes.bool.isRequired,
        onPageChange: PropTypes.func,
        onSortChange: PropTypes.func,
    };

    static defaultProps = {
        loading: false
    };

    componentDidMount() {
        //this.props.clear()
        let id = this.props.match.params.id
        this.props.leerItinerario(id);
    }

    cerrar = (event) => {
        this.props.cerrar(event.target.value);
    }

    render() {
        const { item, data, loader, listar: onPageChange, onSortChange, eliminar, mostrarVista, permisos, cuentas, tipo_gastos } = this.props;
        const fecha = item && item.hora_salida ? new Date(item.hora_salida) : null;
        // Solo afectados correspondientes a empresas
        const desglose_gastos = _.filter(item && item.desglose_gastos ? item.desglose_gastos.afectados : [], (afectado) => {
                                    if (afectado.empresa) return afectado
                                });

        return (
            <LoadMask loading={loader} light type={"TailSpin"}>

                <div className="Container bg-white">
                    {!!item && item.vehiculo && (
                        <div className="m-t p-t fnt-size">
                            <div className="row m-none" style={{ paddingTop: "0px" }}>
                                <div className="col-lg-2 col-md-4 col-12 d-flex align-items-center">
                                    <h3 className="t-primary m-none"> {item ? `No. ${item.id}` : ""}</h3>
                                </div>
                                <div className="col-lg-2 col-md-4 col-12">
                                    <span className="m-none t-mostaza semibold">Estado:  </span>
                                    <span className="m-none t-musgo semibold">{`${item.cerrado ? "Cerrado" : "Abierto"}`}</span>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <span className="m-none t-mostaza semibold">Creado por: </span>
                                    <span className="m-none t-musgo semibold">{`${item.creado_por ? item.creado_por : "Sin registro"}`}</span>,&nbsp;&nbsp;
                                    <RenderDateTime fecha={item.creado}></RenderDateTime>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <span className="m-none t-mostaza semibold">Modificado por: </span>
                                    <span className="m-none t-musgo semibold">{`${item.modificado_por ? item.modificado_por : "Sin registro"}`}</span>,&nbsp;&nbsp;
                                    <RenderDateTime fecha={item.modificado}></RenderDateTime>
                                </div>
                            </div>

                            <div className="col-12">
                                <span className="m-none t-primary bold"> Vehiculo </span>
                            </div>
                            <hr style={{ borderTop: "2px solid rgb(223, 224, 224)", margin: "10px 15px" }} />
                            <div className="row m-none">
                                <div className="col-lg-3 col-md-6 col-12">
                                    <span className="m-none t-mostaza semibold">Placa: </span>
                                    <span className="m-none t-musgo semibold">{`${item.vehiculo.placa}`}</span>
                                </div>
                                <div className="col-lg-3 col-md-6 col-12">
                                    <span className="m-none t-mostaza semibold">kilometraje inicial: </span>
                                    <span className="m-none t-musgo semibold">{item.km_inicial ? `${item.km_inicial} km` : ''}</span>
                                </div>
                                <div className="col-lg-3 col-md-6 col-12">
                                    <span className="m-none t-mostaza semibold">kilometraje final: </span>
                                    <span className="m-none t-musgo semibold">{item.km_final ? `${item.km_final} km` : ''}</span>
                                </div>
                                <div className="col-lg-3 col-md-6 col-12">
                                    <span className="m-none t-mostaza semibold">km Recorrido: </span>
                                    <span className="m-none t-musgo semibold">{item.km_inicial && item.km_final ? `${item.km_final - item.km_inicial} km` : ""}</span>
                                </div>
                            </div>
                            <div className="row m-none">
                                <div className="col-lg-3 col-md-6 col-12">
                                    <span className="m-none t-mostaza semibold">Piloto: </span>
                                    <span className="m-none t-musgo semibold">{`${item.piloto.nombre}`}</span>
                                </div>
                                <div className="col-lg-3 col-md-6 col-12">
                                    <span className="m-none t-mostaza semibold">Telefono: </span>
                                    <span className="m-none t-musgo semibold">{`${item && item.piloto.profile.phone ? item.piloto.profile.phone : ""}`}</span>
                                </div>
                            </div>
                            {
                                (item.ayudante) && (
                                    <div className="row m-none">
                                        <div className="col-lg-3 col-md-6 col-12">
                                            <span className="m-none t-mostaza semibold">Ayudante: </span>
                                            <span className="m-none t-musgo semibold">{`${item.ayudante.nombre}`}</span>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-12">
                                            <span className="m-none t-mostaza semibold">Telefono: </span>
                                            <span className="m-none t-musgo semibold">{`${item && item.ayudante.profile.phone ? item.ayudante.profile.phone : ""}`}</span>
                                        </div>
                                    </div>
                                )
                            }

                            <hr style={{ borderTop: "2px solid rgb(223, 224, 224)", margin: "10px 15px" }} />
                            <div className="row m-none">
                                <div className="col-lg-3 col-md-6 col-12">
                                    <span className="m-none t-mostaza semibold">Fecha de Salida: </span>
                                    <span className="m-none t-musgo semibold">
                                        <RenderDateTime fecha={item.fecha_salida}></RenderDateTime>&nbsp;&nbsp;
                                        {fecha ? "Hora: " + String(fecha.getHours()).padStart(2, '0') + ":" + String(fecha.getMinutes()).padStart(2, '0') : ""}
                                    </span>
                                </div>
                                <div className="col-lg-3 col-md-6 col-12">
                                    <span className="m-none t-mostaza semibold">Fecha de Entrada: </span>
                                    <span className="m-none t-musgo semibold"> <RenderDateTime fecha={item.fecha_entrada}> </RenderDateTime> </span>
                                </div>
                            </div>
                            <br />
                            {
                                item && item.itinerario_interno_detalles && item.itinerario_interno_detalles.length > 0 && (
                                    <GridDespachoInterno
                                        {...this.props}
                                        loader={loader}
                                        page={1}
                                        onPageChange={onPageChange}
                                        onSortChange={onSortChange}

                                        detalles={item.itinerario_interno_detalles}
                                        PDFITINERARIO={this.props.PDFITINERARIO}
                                        estado={item.estado}
                                    />
                                )
                            }
                            {item && item.itinerario_detalle_clientes && item.itinerario_detalle_clientes.length > 0 && (
                                <GridClientesProveedores
                                    {...this.props}
                                    itinerario={item.itinerario_detalle_clientes}
                                    loader={loader}
                                    page={1}
                                    onPageChange={onPageChange}
                                    onSortChange={onSortChange}
                                    paraCliente={true}
                                    PDFITINERARIO={this.props.PDFITINERARIO}
                                    estado={item.estado}
                                    mostrarVista={mostrarVista}
                                />
                            )
                            }
                            {item && item.itinerario_detalle_proveedores && !permisos.visualizar_mis_datos && item.itinerario_detalle_proveedores.length > 0 &&(
                                <GridClientesProveedores
                                    itinerario={item.itinerario_detalle_proveedores}
                                    loader={loader}
                                    page={1}
                                    onPageChange={onPageChange}
                                    onSortChange={onSortChange}
                                    paraCliente={false}
                                    estado={item.estado}
                                />
                            )
                            }
                            {
                                item && item.itinerario_detalle_otros && item.itinerario_detalle_otros.length > 0 && (
                                    <GridOtros
                                        {...this.props}
                                        loader={loader}
                                        page={1}
                                        onPageChange={onPageChange}
                                        onSortChange={onSortChange}

                                        detalles={item.itinerario_detalle_otros}
                                    />
                                )
                            }
                            {item.desglose_gastos &&
                                <div>
                                    <div className=" fnt-size">
                                        <h4 className="t-primary">Desglose de gastos</h4>
                                        <hr style={{ borderTop: "2px solid rgb(223, 224, 224)", margin: "10px 15px" }} />
                                        <div className="row m-none">
                                            <div className="col-lg-4 col-md-6 col-12">
                                                <span className="m-none t-mostaza semibold">Tipo de Pago Piloto: </span><br />
                                                <span className="m-none t-musgo semibold">
                                                    {
                                                        (item.pagoextrapiloto) ? "Extraordinario" : "Normal"
                                                    }
                                                </span>
                                            </div>
                                            {
                                                (item.pagoextrapiloto) && (
                                                    <div className="col-lg-4 col-md-6 col-12">
                                                        <span className="m-none t-mostaza semibold">Nombre del pago: </span><br />
                                                        <span className="m-none t-musgo semibold">{item.pagoextrapiloto.nombre}</span>
                                                    </div>
                                                )
                                            }
                                            {
                                                (item.pagoextrapiloto) && (
                                                    <div className="col-lg-4 col-md-6 col-12">
                                                        <span className="m-none t-mostaza semibold">Monto: </span><br />
                                                        <span className="m-none t-musgo semibold">
                                                            <RenderMoneda monto={item.pagoextrapiloto.monto} />
                                                        </span>
                                                    </div>
                                                )
                                            }
                                        </div>
                                        <div className="row m-none">
                                            <div className="col-lg-4 col-md-6 col-12">
                                                <span className="m-none t-mostaza semibold">Tipo de Pago Ayudante: </span><br />
                                                <span className="m-none t-musgo semibold">
                                                    {
                                                        (item.pagoextraayudante) ? "Extraordinario" : "Normal"
                                                    }
                                                </span>
                                            </div>
                                            {
                                                (item.pagoextraayudante) && (
                                                    <div className="col-lg-4 col-md-6 col-12">
                                                        <span className="m-none t-mostaza semibold">Nombre del pago: </span><br />
                                                        <span className="m-none t-musgo semibold">{item.pagoextraayudante.nombre}</span>
                                                    </div>
                                                )
                                            }
                                            {
                                                (item.pagoextraayudante) && (
                                                    <div className="col-lg-4 col-md-6 col-12">
                                                        <span className="m-none t-mostaza semibold">Monto: </span><br />
                                                        <span className="m-none t-musgo semibold">
                                                            <RenderMoneda monto={item.pagoextraayudante.monto} />
                                                        </span>
                                                    </div>
                                                )
                                            }
                                        </div>
                                        <div className="row m-none">
                                            <div className="col-lg-4 col-md-6 col-12">
                                                <span className="m-none t-mostaza semibold">Categoría de gasto: </span><br />
                                                <span className="m-none t-musgo semibold">{item.desglose_gastos.tipo_gasto ? item.desglose_gastos.tipo_gasto.title : null}</span>
                                            </div>
                                            <div className="col-lg-4 col-md-6 col-12">
                                                <span className="m-none t-mostaza semibold">Fecha: </span><br />
                                                <span className="m-none t-musgo semibold"><RenderDateTime fecha={item.desglose_gastos.fecha} ></RenderDateTime></span>
                                            </div>
                                            <div className="col-lg-4 col-md-6 col-12">
                                                <span className="m-none t-mostaza semibold">Monto: </span><br />
                                                <span className="m-none t-musgo semibold"><RenderMoneda monto={item.desglose_gastos.monto} /*simbolo={getSimbolo(this.props.moneda)} */ /></span>
                                            </div>
                                        </div>
                                        <hr style={{ borderTop: "2px solid rgb(223, 224, 224)", margin: "0px 15px 10px 15px" }} />
                                        <div className="row m-none">
                                            <div className="col-12">
                                                <span className="m-none t-mostaza semibold">Descripción: </span><br />
                                                <span className="m-none t-musgo semibold">{`${item.desglose_gastos.descripcion}`}</span>
                                            </div>
                                        </div>
                                        <div className="row m-none">
                                            <div className="col-12 color-header-blanco">
                                                <hr />
                                                <table className="table table-sm table-responsive-sm m-0">
                                                    <thead>
                                                        <tr>
                                                            <th className="t-mostaza" >Empresa</th>
                                                            <th className="t-mostaza text-right" style={{ width: "20%" }}>Cantidad</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            desglose_gastos && (
                                                                <Fragment>
                                                                    {desglose_gastos.map((empresa, index) => {
                                                                        return (
                                                                            <tr key={index} >
                                                                                <td className="sin-borde-top" style={{ width: "48px" }}>
                                                                                    <span>{empresa.empresa_nombre}</span>
                                                                                </td>
                                                                                <td className="sin-borde-top text-right" style={{ width: "20%" }}>
                                                                                    <RenderMoneda monto={empresa.debe} /* simbolo={getsimbolo(empresa.transaccion.moneda)} */ />
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })}
                                                                </Fragment>
                                                            )
                                                        }
                                                    </tbody>
                                                </table>
                                                <div className="col-md-12 m-0 p-0 mt-1 inline-headers text-center text-md-right">
                                                    <span className="t-mostaza h5 mr-3" htmlFor="descripcion">Total:  </span>
                                                    <h3 className=" t-primary" htmlFor="descripcion">{
                                                        <RenderMoneda monto={item.desglose_gastos.monto} /* simbolo={getsimbolo(item.desglose_gastos.moneda)} */ />
                                                    }</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    )
                    }
                </div>
            </LoadMask>
        )
    }
}
